import styled from 'styled-components';

const StyledHeroIndustries = styled.div`
  position: relative;
  margin-right: 16px;
  margin-left: 16px;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
  text-align: left;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  .industries--hero-bg{
    position: absolute;
    top: 140px;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px; 
    width: 41.65%;
    bottom: 0;
    overflow: hidden;
    left: 50%;
    transform: translateX(-50%);
  }
  h4{
    position: absolute;
    text-align: left;
    color:#000;
    margin: 0 auto;
    max-width: 50%;
    top: 50%;
    padding-left: 48px;
    left: 25%;
    transform: translate(0, -50%);
    z-index: 2;
  }
  img{
    position: absolute;
    width: 50%;
    display: block;
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
  }
  @media screen and (max-width: 1439px){
    
    h4{
      padding-left: 26px;
    }
  }
  @media screen and (max-width: 1023px){
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;
    .industries--hero-bg{
    }
    img{
      width: 74.97%;
    }
  }
  @media screen and (max-width: 767px){
    margin-right: 8px;
    margin-left: 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .industries--hero-bg{
      top: 8px;
      width: 100%;
    }
    h4{
      padding-left: 16px;
      max-width: 100%;
      top: 140px;
      left: 0;
      transform: translate(0, 0);
      color: #fff;
    }
    img{
      bottom: 0;
      width: 100%
    }
  }
`;

export {
  StyledHeroIndustries,
};

